export const TASK_ITEM_INITIALIZE = 'PAGE_TASK_ITEM_INITIALIZE';
export const TASK_ITEM_SELECT_UPDATE_OPTION =
  'PAGE_TASK_ITEM_SELECT_UPDATE_OPTION';
export const TASK_ITEM_FIELD_UPDATE = 'PAGE_TASK_ITEM_FIELD_UPDATE';

export const initialize = () => ({
  type: TASK_ITEM_INITIALIZE
});

export const fieldUpdate = field => ({
  type: TASK_ITEM_FIELD_UPDATE,
  field
});



// WEBPACK FOOTER //
// ./js/actions/page/tasks/TaskItem.js